import { render, staticRenderFns } from "./admin-edit-lead-source-cat.vue?vue&type=template&id=9999a1ec&scoped=true&"
import script from "./admin-edit-lead-source-cat.vue?vue&type=script&lang=js&"
export * from "./admin-edit-lead-source-cat.vue?vue&type=script&lang=js&"
import style0 from "./admin-edit-lead-source-cat.vue?vue&type=style&index=0&id=9999a1ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9999a1ec",
  null
  
)

export default component.exports